import styled from 'styled-components';
import { NoSelect } from '../../../../../styles/mixins';

export const ValueStyled = styled.div`
  position: relative;
  font-size: 14px;
  line-height: 24px;
  ${NoSelect};
  width: 100%;
  text-align: center;
`;
